<template>
    <BreadCrumb PageTitle="Ajouter un organe" />
    <AjouterOrgane />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue"
import AjouterOrgane from "@/components/Organes/AjouterOrgane.vue";

export default defineComponent({
    name: "AjouterOrganePage",
    components: {
        BreadCrumb,
        AjouterOrgane,
    },
});
</script>